// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pe_a bht_sn bht_sv bht_sw bht_kx bht_ky bht_ke undefined bht_vt"};